<cw-ci-data-table #assessmentDataTable
  tileTitle="Assessments"
  refreshToolTip="Reload assessment list"
  defaultSortField="updatedAt"
  defaultSortDirection="desc"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadAssessments($event)"
  (selectHandler)="selectAssessment($event)"
  [items]="assessmentList">

  <!-- <cw-ci-table-column columnName="id" columnTitle="Id" sortField="id"></cw-ci-table-column> -->

  <cw-ci-table-column columnName="assessmentName" columnTitle="Name"></cw-ci-table-column>

  <cw-ci-table-column columnName="score" columnTitle="Risk" [output]="riskTemplate" sortField="score"></cw-ci-table-column>
  <ng-template let-element #riskTemplate>
    <div *ngIf="element.score" [ngStyle]="{'color':getRiskColor(element.score)}"><mat-icon svgIcon="cw:flag_risk" style="vertical-align:middle"></mat-icon><span style="vertical-align:middle">{{getRiskLabel(element.score)}}</span></div>
    <div *ngIf="!element.score">-</div>
  </ng-template>

  <cw-ci-table-column columnName="percentComplete" columnTitle="Assessment Progress" sortField="percentComplete" [output]="percentCompleteTemplate"></cw-ci-table-column>
  <ng-template let-element #percentCompleteTemplate>
    <div class="custom-progress-bar" [ngClass]="{'progress-not-started':element.percentComplete==0}" style="width:200px">
      <div *ngIf="element.percentComplete>0" class="bg-primary" [ngStyle]="{'width': element.percentCompleteStr}">{{element.percentCompleteStr}}</div>
      <div *ngIf="element.percentComplete==0" class="bg-warn">{{element.percentComplete}}</div>
    </div>
  </ng-template>

  <cw-ci-table-column columnName="updatedAt" columnTitle="Assessment Updated" sortField="updatedAt" [output]="updatedTemplate"></cw-ci-table-column>
  <ng-template let-element #updatedTemplate>{{element.updatedAt | date:'short'}}</ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action [visible]="element.status === 'COMPLETED'" actionToolTip="View the assessment dashboard" svgIcon="cw:action_toggle_graph" actionColor="primary" [element]="element" (clickHandler)="selectAssessment($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action [visible]="element.status !== 'COMPLETED'" actionToolTip="Work on the assessment" svgIcon="cw:application_appcues" actionColor="primary" [element]="element" (clickHandler)="selectAssessment($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action [visible]="element.status === 'COMPLETED' && element.isLatest" actionToolTip="Create a new assessment" svgIcon="cw:action_add" actionColor="primary" [element]="element" (clickHandler)="newAssessment($event)"></cw-ci-table-column-action>
  </ng-template>
</cw-ci-data-table>